import React, { useRef, useEffect, useContext } from "react";
import { css } from "@emotion/react";
import { gsap, ScrollToPlugin } from "gsap/all";
import { LoadContext } from "@providers/LoadProvider";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import Logo from '@components/Logo.js';
gsap.registerPlugin(ScrollToPlugin);
const Loader = () => {
  const { video } = useContext(LoadContext);
  const loaderRef = useRef(null);
  useEffect(() => {
    disableBodyScroll(loaderRef.current);
    gsap.to(window, {
      duration: 0.1,
      scrollTo: 0,
    });
    return clearAllBodyScrollLocks;
  }, []);
  useEffect(() => {
    if (video) {
      gsap.to(loaderRef.current, {
        opacity: 0,
        pointerEvents: "none",
        delay: 0.65,
        duration: 0.35,
      });
      enableBodyScroll(loaderRef.current);
    }
  }, [video]);

  return (
    <div
      ref={loaderRef}
      css={css`
        height: 100vh;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #E2D3D1;
        z-index: 20;
      `}
    >
      <Logo /> 
    </div>
  );
};
export default Loader;